import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Widget, WidgetType } from '../../../core/models';
import { CloudStorageBannerWidgetComponent } from '../cloud-storage-banner-widget/cloud-storage-banner-widget.component';
import { MiniBannerListWidgetComponent } from '../mini-banner-list-widget/mini-banner-list-widget.component';
import { MobileAppBannerWidgetComponent } from '../mobile-app-banner-widget/mobile-app-banner-widget.component';
import { MiniBannerWidgetComponent } from '../mini-banner-widget/mini-banner-widget.component';
import { LinkWidgetComponent } from '../links-list-widget/links-list-widget.component';
import { FaqWidgetComponent } from '../faq-widget/faq-widget.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'sc-widget-list',
  imports: [
    CloudStorageBannerWidgetComponent,
    MiniBannerListWidgetComponent,
    MobileAppBannerWidgetComponent,
    MiniBannerWidgetComponent,
    LinkWidgetComponent,
    FaqWidgetComponent,
    NgClass,
  ],
  templateUrl: './widget-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetListComponent {
  public widgetList = input<Widget[]>();
  public firstItemMargin = input<boolean>(true);

  public widgetType = WidgetType;
}
